import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BRAND, NAV_LINKS, waLink, telLink } from "@/data/content";
import { scrollToSection } from "@/hooks/useLenis";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-[#111111]/85 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => go("#inicio")}
          className="flex items-center"
        >
          <img src={BRAND.logo} alt="K2 Guincho 24h - Guincho 24 horas em São Paulo" className="h-11 w-auto sm:h-14" />
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="font-mono-t text-xs uppercase tracking-[0.15em] text-zinc-400 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-call-btn"
            href={telLink}
            className="hidden items-center gap-2 border border-white/20 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-white transition-colors duration-200 hover:border-[#D50000] hover:text-[#D50000] sm:flex"
          >
            <Phone size={15} /> {BRAND.phoneDisplay}
          </a>
          <a
            data-testid="nav-whatsapp-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden bg-[#D50000] px-5 py-2 text-xs font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-[#B00000] md:block"
          >
            Solicitar Guincho
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="text-white lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-white/10 bg-[#111111] px-5 py-6 lg:hidden"
        >
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                onClick={() => go(l.href)}
                className="text-left font-display text-2xl uppercase tracking-tight text-white"
              >
                {l.label}
              </button>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 bg-[#D50000] px-5 py-3 text-center text-sm font-bold uppercase tracking-wider text-white"
            >
              Solicitar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
